webpackJsonp([114276838955818,60335399758886],{

/***/ 131:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(268);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(131);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(68);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(384);
	
	__webpack_require__(385);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Line.fm \uD835\uDE3E\uD835\uDE61\uD835\uDE56\uD835\uDE68\uD835\uDE68\uD835\uDE5E\uD835\uDE58'
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: 'https://classic.line.fm' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: 'https://classic.line.fm/static/Favicon@4x.png' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Line.fm \uD835\uDE3E\uD835\uDE61\uD835\uDE56\uD835\uDE68\uD835\uDE68\uD835\uDE5E\uD835\uDE58' }),
	      _react2.default.createElement('meta', {
	        property: 'og:description',
	        content: 'Good tunes on autopilot \uD83C\uDFB5\u2708\uFE0F\uD83D\uDE0E. Listen to all tunes from @wipmusic. (RIP)'
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' })
	    ),
	    children()
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5ea444e6b25a52daadaa.js